import FilterBar from 'components/common/FilterBar';
import { ISingleFilterOptionProps } from 'components/common/FilterBar/types';
import { LoggerActionEnum } from 'constants/logger';
import React from 'react';
import { FilterContainerStyled } from 'routes/Appointments/components/AppointmentFilterBars/styled';
import { GeneralFunction } from 'types/common';

const TransactionLogFilters: React.FC<{
  onUserFilterScrollToGetNextData: GeneralFunction;
  userFilterOptions: ISingleFilterOptionProps[];
}> = ({ userFilterOptions }) => {
  const filterByActionOptions = Object.entries(LoggerActionEnum).map(([value, label]) => ({ label, value }));

  return (
    <div className='flex p-4 flex-wrap border-b border-border_color'>
      <FilterContainerStyled style={{ width: 300, maxWidth: '33%' }}>
        <FilterBar notSpecifiedValueLabel='By User: All' options={userFilterOptions} name='user' />
      </FilterContainerStyled>
      <FilterContainerStyled className='sm:ml-4 mt-4 sm:mt-0' style={{ width: 300, maxWidth: '33%' }}>
        <FilterBar notSpecifiedValueLabel='By Actions: All' options={filterByActionOptions} name='activityType' />
      </FilterContainerStyled>
    </div>
  );
};

export default React.memo(TransactionLogFilters);
